export enum APPLICATION_TYPE {
  ADMIN = 'uplift-admin',
  USER = 'uplift-user',
  THERAPIST = 'uplift-therapist'
}
